import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const createHelpers = (width, height, css) => {
    // somehow sizes is ending up in markup, even if it is not a valid svg attribute
    // until we have a better solution, just render it empty, instead to '[Object object]'
    const sanitizeSizes = sizes =>
        Object.defineProperty(sizes, "toString", {
            value: () => "",
            enumerable: false
        });

    const getDimensions = (size, sizes) => {
        if (
            size &&
            typeof size.width === "number" &&
            typeof size.height === "number"
        ) {
            return size;
        }

        return size && sizes[size] ? sizes[size] : { width, height };
    };

    const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
        if (noStyles) {
            return "";
        }

        const dimensions = getDimensions(size, sizes);
        const fillRule =
            fillColor && fillColorRule
                ? `${fillColorRule}{ fill: ${fillColor}; }`
                : "";

        return css`
            width: ${dimensions.width}px;
            height: ${dimensions.height}px;
            ${fillRule}
        `;
    };

    const propsToCss = ({ size, sizes, fillColor, fillColorRule, noStyles }) =>
        getCss(size, sizes, fillColor, fillColorRule, noStyles);

    return {
        getCss,
        getDimensions,
        propsToCss,
        sanitizeSizes
    };
};

const width = "40";
const height = "40";
const viewBox = "0 0 40 40";

const { getDimensions, getCss, propsToCss, sanitizeSizes } = createHelpers(
    width,
    height,
    css
);

const sizes = sanitizeSizes({
    xs: { width: 14, height: 14 },
    sm: { width: 16, height: 16 },
    md: { width: 20, height: 20 },
    lg: { width: 24, height: 24 },
    xl: { width: 40, height: 40 }
});

const Image = styled.svg`
    ${propsToCss}
`;

const children = (
    <Fragment>
        <path fill="url(#pattern6)" d="M0 0h40v40H0z" key="key-0" />
        <defs key="key-1">
            <pattern
                id="pattern6"
                width="1"
                height="1"
                patternContentUnits="objectBoundingBox"
            >
                <use transform="scale(.00417)" xlinkHref="#image6" />
            </pattern>

            <image
                id="image6"
                width="240"
                height="240"
                xlinkHref="data:image/png;base64,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"
            />
        </defs>
    </Fragment>
);

const defaultProps = {
    children,
    viewBox,
    fillColor: null,
    fillColorRule: "&&& path, &&& use, &&& g",
    sizes,
    size: null
};

Image.propTypes /* remove-proptypes */ = {
    fillColor: PropTypes.string,
    fillColorRule: PropTypes.string,
    viewBox: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            height: PropTypes.number.isRequired,
            width: PropTypes.number.isRequired
        })
    ]),
    sizes: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number
    })
};

export default Object.assign(Image, {
    getDimensions,
    getCss,
    defaultProps,
    displayName: "Windows"
});
